/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lp_Login_Subscribedescription1Inputs */

const en_lp_login_subscribedescription1 = /** @type {(inputs: Lp_Login_Subscribedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request, complete, and manage the subscription digitally`)
};

/**
* | output |
* | --- |
* | "Request, complete, and manage the subscription digitally" |
*
* @param {Lp_Login_Subscribedescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lp_login_subscribedescription1 = /** @type {((inputs?: Lp_Login_Subscribedescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lp_Login_Subscribedescription1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lp_login_subscribedescription1(inputs)
});
export { lp_login_subscribedescription1 as "lp_login_subscribeDescription" }